import SafeImage from "@components/SafeImage";
import { GetFeaturedImage } from "@services/ProductImages";
import { FlexBox } from "@styles";
import { Link } from "gatsby";
import React from "react";
import { FaGreaterThan, FaLessThan, FaTimes } from "react-icons/fa";
import styled from "styled-components";

interface ColorInfoModalProps {
  currentColor: Queries.ProductFragment;
  closeModal: () => void;
  prevColor: (() => void) | null;
  nextColor: (() => void) | null;
}

const ModalContainer = styled.div`
  position: fixed;
  z-index: 100;
  left: 0;
  top: 10vh;
  left: 50%;
  transform: translate(-50%, 0);
  max-height: 90vh;
  max-width: 100vw;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fefefe;
  margin: auto;
  padding: 0.5rem;
  border: 1px solid #888;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  gap: 0.5rem;

  border-radius: 5px;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;

  width: 100%;
`;

const ColorInfoModal: React.FC<ColorInfoModalProps> = ({ currentColor, closeModal, prevColor, nextColor }) => {
  const featuredImage = GetFeaturedImage([...currentColor.external_images], currentColor.product_name ?? "unknown");

  return (
    <ModalContainer>
      <ModalHeader>
        {prevColor && <FaLessThan onClick={prevColor} />}
        {nextColor && <FaGreaterThan onClick={nextColor} />}

        <FaTimes onClick={closeModal} />
      </ModalHeader>
      <ModalContent>
        <h3>{currentColor.products_colors?.color.color_name}</h3>
        <Link className="text-base underline pb-4 " to={`/products/${currentColor.slug}`}>
          Full Product Detail
        </Link>
        {featuredImage && (
          <FlexBox style={{ maxHeight: "80vh", maxWidth: "90vw" }}>
            <SafeImage src={featuredImage?.fullImageUrl} alt={featuredImage.altText} style={{ maxHeight: "70vh", maxWidth: "90vw" }} />
          </FlexBox>
        )}
      </ModalContent>
    </ModalContainer>
  );
};

export default ColorInfoModal;
